import { render, staticRenderFns } from "./TPieIcon.vue?vue&type=template&id=7e7d77c8&scoped=true&"
import script from "./TPieIcon.vue?vue&type=script&lang=js&"
export * from "./TPieIcon.vue?vue&type=script&lang=js&"
import style0 from "./TPieIcon.vue?vue&type=style&index=0&id=7e7d77c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7d77c8",
  null
  
)

/* custom blocks */
import block0 from "./TPieIcon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports